/**
 * src/components/ui/Skeleton.jsx — loading placeholder block.
 *
 * Reuses styles.css's existing `.loading-pulse` keyframe (already wrapped
 * in `@media (prefers-reduced-motion: no-preference)` — see that file's
 * Motion section) rather than defining a second pulse animation, so
 * reduced-motion handling stays in the one place that already gets it
 * right.
 */

/**
 * @param {{ width?: string, height?: string, radius?: boolean, className?: string }} props
 *   `radius` — true for a rounded block (a text line), false for a fully
 *   round one (an avatar placeholder).
 * @returns {JSX.Element}
 */
export function Skeleton({ width = '100%', height = '14px', radius = true, className }) {
  return (
    <span
      className={`ui-skeleton loading-pulse${className ? ` ${className}` : ''}`}
      style={{ width, height, borderRadius: radius ? 'var(--radius)' : '999px' }}
      aria-hidden="true"
    />
  );
}
